import React from 'react';
import icon from 'assets/ppsc_images/WellTrajectoryLogo.png';

const Icon = ({ width }) => <img src={icon} alt="WellTrajectory" width={width || '25'} />;

export default Icon;
